<div id="generate-activities-test" class="m-3">

    <h1>Generar actividades / evaluación</h1>

    <div id="activity-type" class="mx-0 my-3">
        <p class="fw-bold">¿Qué tipo de actividad desea generar?</p>
        <label for="activity-type-activity" class="d-block">
            <input type="radio" name="activity-type" id="activity-type-activity" class="me-1" value="activity" 
                [(ngModel)]="activityType" (ngModelChange)="reset()">
            <span>Actividades (rellenar espacios en blanco)</span>
        </label>
    
        <label for="activity-type-test" class="d-block">
            <input type="radio" name="activity-type" id="activity-type-test" class="me-1" value="test" 
                [(ngModel)]="activityType" (ngModelChange)="reset()">
            <span>Evaluación (preguntas abiertas)</span>
        </label>
    </div>

    <div id="text-source" class="mx-0 my-3">
        <p class="fw-bold">¿De dónde viene el texto con el que se generarán actividades?</p>
        <label for="text-source-heading" class="d-block">
            <input type="radio" name="text-source" id="text-source-heading" class="me-1" value="heading"
                [(ngModel)]="textSource" (ngModelChange)="reset()">
            <span>De un enunciado del curso</span>
        </label>

        <label for="text-source-text" class="d-block">
            <input type="radio" name="text-source" id="text-source-text" class="me-1" value="text" 
                [(ngModel)]="textSource" (ngModelChange)="reset()">
            <span>Es un texto indepediente</span>
        </label>
    </div>

    <div id="text-source-heading" *ngIf="textSource === 'heading'">
        <label for="course-units" class="d-block" *ngIf="courseUnits">
            <p class="fw-bold">Unidad:</p>
            <select #courseUnitsSelect name="course-units" id="course-units" [(ngModel)]="selectedUnit"
                (ngModelChange)="selectUnit($event)">
                <option disabled selected value="-1">Seleccione una unidad...</option>
                <option *ngFor="let unit of courseUnits" value="{{ unit.id }}">
                    {{ unit.name }}
                </option>
            </select>
        </label>

        <label for="units-lessons" class="d-block" *ngIf="unitLessons">
            <p class="fw-bold">Lección:</p>
            <select #unitLessonsSelect name="unit-lessons" id="unit-lessons" [(ngModel)]="selectedLesson"
                (ngModelChange)="selectLesson($event)">
                <option disabled selected value="-1">Seleccione una lección...</option>
                <option *ngFor="let lesson of unitLessons" value="{{ lesson.id }}">
                    {{ lesson.name }}
                </option>
            </select>
        </label>
    </div>

    <div id="generate-activities-test-options" *ngIf="selectedLesson > 0">
        <label for="numDistractors" class="d-block">
            <p>Número de distractores:</p>
            <input type="number" [(ngModel)]="numDistractors" min="3">
        </label>
        <label for="numQuestions" class="d-block">
            <p>Número de preguntas a generar:</p>
            <input type="number" [(ngModel)]="numQuestions" min="2">
        </label>
    </div>

    <div id="text-source-text" *ngIf="textSource === 'text'">
        <label for="text" class="d-block">
            <p>Texto:</p>
            <textarea name="text" id="text" [(ngModel)]="activitiesText" (input)="changeActivitiesText()">
            </textarea>
        </label>
    </div>

    <div id="generate-activities-status" class="mt-3">
        <div id="generate-activities-spinner" *ngIf="generateActivitiesLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="generate-activities-error" class="text-danger" *ngIf="generateActivitiesError">
            <i class="fa fa-times"></i>
            <span>No se han podido generar actividades. Por favor, inténtelo con otra lección u otro texto.</span>
        </div>
        <div id="generate-activities-success" class="text-success" *ngIf="generateActivitiesSuccess">
            <i class="fa fa-check"></i>
            <span>{{ activitiesResultText }}<br>Se muestran abajo para que pueda editarlas antes de insertarlas.</span>
            <!-- Ahora será redireccionado, espere un momento... -->
        </div>
    </div>

    <div id="generate-activities-buttons">
        <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button disabled class="btn btn-success me-3" (click)="generateActivities()"
            [attr.disabled]="activitiesBtnDisabled ? 'disabled' : null">
            <i class="fas fa-check-square"></i>
            <span>Generar actividades</span>
        </button>
    </div>

    <div id="generate-activities-result" *ngIf="activitiesResult" class="mt-3 mb-3">
        <p class="fw-bold">Resultado:</p>
        <div class="card" *ngFor="let activity of activitiesResult; let a = index;">
            <div class="card-header">
                <p class="fw-bold">Pregunta #{{ a + 1 }}</p>
                <!-- <p>{{ activity.sentence }}</p> -->
                <input type="text" [(ngModel)]="activity.sentence" [size]="activity.sentence.length">
            </div>
            <div class="card-body">
                <p class="fw-bold">Opciones (Solución marcada):</p>
                <ul>
                    <li *ngFor="let option of activity.options; let o = index; trackBy: trackByFn;">
                        <label for="activity_{{ a }}_option_{{ o }}" class="d-block">
                            <input type="radio" id="activity_{{ a }}_option_{{ o }}_radio" name="activity_{{ a }}_options" value="{{ option }}" [attr.checked]="option === activity.solution ? 'checked' : null" (click)="activity.solution = option">
                            <input type="text" id="activity_{{ a }}_option_{{ o }}_text" name="activity_{{ a }}_option_{{ o }}_text" [ngModel]="activity.options[o]" (ngModelChange)="changeOption(a, o, $event)">
                            <button class="btn btn-danger m-3" (click)="deleteOption(a, o)">
                                <i class="fa fa-minus"></i>
                            </button>
                            <!-- <span>{{ option }}</span> -->
                            <!-- {{ option }} -->
                        </label>
                    </li>
                </ul>
                <button class="btn btn-primary m-3" (click)="newOption(a)">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
            <div class="card-footer">
                <p class="fw-bold">Solución:</p>
                <p>{{ activity.solution }}</p>
            </div>
        </div>

        <div id="insert-activities">

            <label for="" class="d-block">
                <input type="checkbox" class="me-2" name="deleteActivities" [(ngModel)]="resetActivities">
                <span>¿Desea reemplazar las actividades existentes por las recién generadas?</span>
            </label>

            <p class="mb-0">Una vez haya terminado de curar las actividades, pulse este botón para insertarlas en la lección especificada.</p>
            <button class="btn btn-primary m-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
                <i class="fa fa-arrow-left"></i>
                <span>Volver</span>
            </button>
            <button class="btn btn-success m-3" (click)="saveActivities()">
                <i class="fa fa-save"></i>
                <span>Guardar actividades</span>
            </button>

            <div id="insert-activities-status">
                <div id="insert-activities-loading" *ngIf="insertActivitiesLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Procesando, espere por favor...</span>
                </div>
                <div id="insert-activities-error" class="text-danger" *ngIf="insertActivitiesError">
                    <i class="fa fa-times"></i>
                    <span>No se han podido insertar las actividades. Por favor, inténtelo de nuevo.</span>
                </div>
                <div id="insert-activities-success" class="text-success" *ngIf="insertActivitiesSuccess">
                    <i class="fa fa-check"></i>
                    <span>Se han insertado las actividades correctamente en la lección especificada.</span>
                    <!-- Ahora será redireccionado, espere un momento... -->
                </div>
            </div>
        </div>
    </div>
</div>